import { Fragment, useContext, useEffect, useState } from "react";
import { LinkProductPage } from "../../Layout/Common/LinkProductPage";
import { ImageWithDefault } from "../../Layout/Common/imageWithDefault";
import { GlobalContext } from "../../Context/GlobalContext";
import { OrderSummaryRowSkeleton } from "../../Skeleton/OrderSummaryRowSkeleton";
import { ConvertToFloat, isValidArray } from "../../Layout/Common/common";
import { ISPICKUPONLY_MESSAGE } from "../../constants";
import { LoadMoreCartItem } from "../../Layout/Common/cartItemDynamicLoad";
import { ItemReferenceInput } from "../../Layout/Common/itemReferenceInput";

export const OrderSummaryRow = ({ cartItem: cartItemProp }) => {
  const [cartItem, setCartItem] = useState(null);
  const [cartDetails, setCartDetails] = useState(null);
  const globalcontext = useContext(GlobalContext);

  useEffect(() => {
    if (cartItemProp && isValidArray(cartItemProp.cartItem)) {
      setCartDetails(cartItemProp);
      setCartItem(cartItemProp.cartItem);
      return;
    }
    if (globalcontext.CartItem && isValidArray(globalcontext.CartItem.cartItem)) {
      setCartDetails(globalcontext.CartItem);
      setCartItem(globalcontext.CartItem.cartItem);
    }
  }, [cartItemProp, globalcontext.CartItem]);

  return (
    <Fragment>
      <div className="order-summary-items ">
        {cartDetails && isValidArray(cartItem) ? (
          <Fragment>
            {cartItem.map((r, index) => (
              <div className="selected-products" key={index}>
                <div className="selected-products-img added-cartPro-img">
                  <ImageWithDefault src={r.image_th} alt={r.description} />
                </div>
                <div className="selected-products-info web-fill-width">
                  <h5>
                    <LinkProductPage productCode={r.prod_code} value={r.description} />
                  </h5>
                  {isValidArray(globalcontext.pickupOnlyProduct) &&
                    globalcontext.pickupOnlyProduct.includes(String(r.prod_id)) && (
                      <div className="text-danger form-validation-message">{ISPICKUPONLY_MESSAGE}</div>
                    )}
                  <div className="added-cartPro-price">
                    <p>
                      Qty: {r.qty} <span>Code: {r.prod_code}</span>
                    </p>
                    <p>Price: ${ConvertToFloat(r.total_ext)}</p>
                  </div>
                  <ItemReferenceInput item={r} />
                </div>
              </div>
            ))}
          </Fragment>
        ) : (
          <OrderSummaryRowSkeleton />
        )}
      </div>
      <LoadMoreCartItem
        orderId={globalcontext.OrderId}
        cartItem={cartItem}
        totalItem={cartDetails ? cartDetails.totalItem : 0}
        onItemsLoaded={(newItems) => setCartItem((prev) => [...prev, ...newItems])}
      />
    </Fragment>
  );
};
